import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as UploadIcon } from './upload.svg';

export const Upload = IconHOC(UploadIcon);
